module.exports = __webpack_public_path__ + "img/hoehle2.70ee454a.jpg";